// Gross | Adjusted display-mode state. Shared between ScorecardPage and
// RoundLeaderboardPage so a toggle on either surface flips both — a single
// localStorage key + a custom event so peer components stay in sync
// without a global store.

import { useEffect, useState, useCallback } from 'react'

const KEY = 'tf_display_mode'
const EVENT = 'tf-display-mode-changed'

function readMode() {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'adjusted' ? 'adjusted' : 'gross'
  } catch { return 'gross' }
}

export function useDisplayMode() {
  const [mode, setModeState] = useState(readMode)

  useEffect(() => {
    const onChange = () => setModeState(readMode())
    window.addEventListener(EVENT, onChange)
    window.addEventListener('storage', onChange)
    return () => {
      window.removeEventListener(EVENT, onChange)
      window.removeEventListener('storage', onChange)
    }
  }, [])

  const setMode = useCallback((next) => {
    const v = next === 'adjusted' ? 'adjusted' : 'gross'
    try { localStorage.setItem(KEY, v) } catch {}
    setModeState(v)
    try { window.dispatchEvent(new Event(EVENT)) } catch {}
  }, [])

  return [mode, setMode]
}
